<template>
  <span v-if="!isReadOnly" class="dpwrapper">
    <hy-date :id="id" v-model="date" :placeholder="placeholder"/>
  </span>
  <span v-else-if="dateString" >{{dateString}}</span>
  <span v-else>&ZeroWidthSpace;{{ nullDisplayValue }}</span> <!-- wenn attribute ungesetzt ist stelle Whitespace dar, damit regulärere Platz reserviert wird-->
  <!-- Datepicker? -->
  <!-- https://icehaunter.github.io/vue3-datepicker/ -->
  <!-- https://www.npmjs.com/package/vue3-datepicker-lite/v/1.9.1 -->
</template>

<script>
import {date2XMLRDB} from "../../utils/date"
import Attribute from "../../xmlrdb-data/Attribute"
import { computed } from "vue"
import HyDate from "../../basic-components/HyDate.vue";


function date2Datefield(date) {
  const d = date2XMLRDB(date);
  return d.substring(0,10);
}

export default {

  name: "dateField",
  props: {
    attribute: Attribute,
    isReadOnly: Boolean,
    placeholder: String,
    nullDisplayValue: { type: String, default: "-" },
    id: String 
  },
  components: {
    HyDate
  },
  // Steuert in der Attribute - Komponente ob das erzeugte Label als Click-Label für die Input-Komponente agieren soll
  // clickableAttributeLabel: true, 
  clickableContainer: true,
  setup(props){

    const date = computed({
      set(newStringDate){
        // hat sich das Datum verändert?
        let hasChanged = (!!newStringDate) != (!!props.attribute.value); // Alt und neu beide (un)gesetzt?
        if (!hasChanged && newStringDate) { 
          // Beide gesetzt und unterschiedlich? 
          hasChanged = !newStringDate.startsWith(date2Datefield(props.attribute.value));
        }
        if(hasChanged){
          if(newStringDate){
            props.attribute.value = new Date(newStringDate);
          }
          else{
            props.attribute.value = null
          }
        }
      },
      get(){
        if( props.attribute.value instanceof Date){
          return date2Datefield(props.attribute.value); // nur den Date-Teil
        }
        return "";
      }
    });

    function getDateString(){
      const date = props.attribute.value;
      if( props.attribute.value && !Number.isNaN(date.getTime())){
        return date.toLocaleDateString(undefined, { day: "2-digit", year: "numeric", month:"2-digit"})
      }
      return props.placeholder;
    }

    return {
      dateString: computed(getDateString),
      date
    }
  }
}

</script>

<style scoped>

</style>